module.exports = __webpack_public_path__ + "img/cns_printer_pc4.729e0616.png";